import React from 'react'
import Head from 'next/head'
import NewPost from 'components/article/createPost'
import { Create_Faq_PageDocument } from 'graphql/generated/types'
import ApplicationLayout from 'layouts/application'
import { initializeApollo, addApolloState } from 'util/apolloClient'

const title = `Create Post`
const description = `Create Post`

export async function getStaticPaths() {
  return {
    paths: [
      { params: { country_slug: 'ca' } },
      { params: { country_slug: 'us' } },
      { params: { country_slug: 'in' } },
    ],
    fallback: false,
  }
}

export default function CreateFaq(props) {
  const { data: pageData } = props

  const {
    all_brokers: { data: allBrokers },
    nav_calculators: { data: navCalculators },
    all_categories: { data: allCategories },
    all_pages: { data: allPages },
  } = pageData

  return (
    <ApplicationLayout
      allBrokers={allBrokers}
      navCalculators={navCalculators}
      allPages={allPages}
    >
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <NewPost categories={allCategories} />
    </ApplicationLayout>
  )
}

export async function getStaticProps() {
  const apolloClient = initializeApollo()

  const queryResults = await apolloClient.query({
    query: Create_Faq_PageDocument,
  })
  const { data } = queryResults

  return addApolloState(apolloClient, { props: { data } })
}
